import { useState, useEffect, useRef } from 'react';
import cn from 'classnames';

import useClickOutside from '../../hooks/useClickOutside.js';
import MegaMenuColumnItem from './MegaMenuColumnItem.jsx';
import useFocusOutside from '../../hooks/useFocusOutside.js';
import useMergeRefs from '../../hooks/useMergeRefs.js';
import LdsIcon from '../LdsIcon/index.jsx';
export default function MegaMenuColumn({
  menuIndex,
  columnIndex,
  menuName,
  menuItems = [],
  isMobile,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const collapsableMenuRef = useRef(null);
  const [height, setHeight] = useState(0);
  // header menu is mobile if the screen width is less than 900px
  const clickOutsideRef = useClickOutside(() => {
    setIsOpen(false);
  });
  const focusOutsideRef = useFocusOutside(() => {
    setIsOpen(false);
  });
  const mergedRefs = useMergeRefs(clickOutsideRef, focusOutsideRef);

  useEffect(() => {
    if (isOpen) {
      setHeight(`${collapsableMenuRef.current.scrollHeight}px`);
    } else {
      setHeight('0px');
    }
  }, [isOpen, collapsableMenuRef]);

  const containerMenuClasses = cn('lds-header-mega-menu-container-menu', {
    'lds-header-mega-menu-container-menu-active': isOpen,
  });
  const Tag = isMobile ? 'button' : 'div';

  return (
    <div ref={mergedRefs} className={containerMenuClasses}>
      <div
        className="lds-header-mega-menu-container-menu-title mega-menu-column-button-wrapper"
        // aria attributes are only added if the menu is mobile
        aria-labelledby={
          isMobile
            ? `lds-header-mega-menu-list-heading-${menuIndex}-${columnIndex}`
            : null
        }
        aria-controls={
          isMobile
            ? `lds-header-mega-menu-column-${menuIndex}-${columnIndex}`
            : null
        }
        aria-expanded={isMobile ? isOpen : null}
      >
        <Tag
          id={`lds-header-mega-menu-list-heading-${menuIndex}-${columnIndex}`}
          data-testid={`header-menu-button-${menuName.replace(/\s+/g, '-')}`}
          className="lds-header-menu-item-heading mega-menu-column-button lds-header-menu-item-button toggleMegaColumn"
          onClick={() => setIsOpen(!isOpen)}
          tabIndex={isMobile ? '0' : '-1'}
        >
          {menuName}
          <LdsIcon
            decorative
            className="mega-menu-caret-down will-rotate"
            inline
            name="CaretDown"
          />
        </Tag>
      </div>
      <div
        id={`lds-header-mega-menu-column-${menuIndex}-${columnIndex}`}
        className="lds-header-mega-menu-menus-container"
        ref={collapsableMenuRef}
        style={{ maxHeight: height }}
      >
        <ul
          aria-labelledby={`lds-header-mega-menu-list-heading-${menuIndex}-${columnIndex}`}
          className="lds-header-menu lds-header-menu-generic lds-header-menu-right"
          id={
            isMobile
              ? `lds-header-mega-menu-column-${menuIndex}-${columnIndex}`
              : null
          }
        >
          {menuItems.map((item, index) => (
            <MegaMenuColumnItem
              key={index}
              {...item}
              isOpen={isOpen}
              isMobile={isMobile}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}
